import Vue from "vue";
import Router from "vue-router";

import OrdersQueue from "@/views/OrdersQueue";
import Login from "@/views/Login";
import CreateOrder from "@/views/CreateOrder";
import Archive from "@/views/Archive";
import Tables from "@/views/Tables";
import Preorder from "@/views/Preorder";
import Delivery from "@/views/Delivery";
import Orders from "@/views/Orders";
import Notifications from "@/views/Notifications";
import SplitAction from "@/views/SplitAction";
import MergeAction from "@/views/MergeAction";
import ChooseTable from "@/views/ChooseTable";
import EditAction from "@/views/EditAction";
import CreatePreorder from '@/views/CreatePreorder.vue'
import CreateReserve from '@/views/CreateReserve.vue'
import EditPreorder from '@/views/EditPreorder.vue'
import Stoplist from "@/views/Stoplist.vue"

Vue.use(Router);

export default new Router({
  mode: process.env.VUE_APP_TEST_BUILD ? "hash" : "history",
  routes: [
    {
      path: "/",
      component: Login,
    },
    {
      path: "/login",
      component: Login,
    },
    {
      name: 'link_login',
      path: "/login/:qid",
      component: Login,
    },
    {
      path: "/list",
      component: OrdersQueue,
    },
    {
      path: "/create/:section/:table",
      name: "create_order",
      component: CreateOrder,
    },
    {
      path: "/create",
      name: "create_order_choose",
      component: ChooseTable,
    },
    {
      path: '/create_preorder',
      name: 'create_preorder',
      component: CreatePreorder
    },
    {
      path: '/create_delivery',
      name: 'create_delivery',
      component: CreatePreorder
    },
    {
      path: '/create_reserve',
      name: 'create_reserve',
      component: CreateReserve
    },
    {
      path: "/archive",
      name: "archive",
      component: Archive,
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
    },
    {
      path: "/tables",
      name: "tables",
      component: Tables,
    },
    {
      path: "/preorder",
      component: Preorder,
    },
    {
      path: "/delivery",
      component: Delivery,
    },
    {
      path: "/notifications",
      component: Notifications,
    },
    {
      path: "/split/:order_id",
      name: "split_action",
      component: SplitAction,
    },
    {
      path: "/merge/:order_id",
      name: "merge_action",
      component: MergeAction,
    },
    {
      path: "/move/:order_id",
      name: "move_action",
      component: ChooseTable,
    },
    {
      path: "/to_inside/:preorder_id",
      name: "to_inside",
      component: ChooseTable,
    },
    {
      path: "/edit/:order_id",
      name: "edit_action",
      component: EditAction,
    },
    {
      path: '/stoplist',
      name: 'stoplist',
      component: Stoplist
    },
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/edit_preorder/:preorder_id',
      name: 'edit_preorder',
      component: EditPreorder
    }
  ],
});
